import React, {useCallback, useState} from "react";
import {Popover as MuiPopover} from "@mui/material";


export const Popover = ({
                            id,
                            popoverChild,
                            child,
                            elevation = 1,
                            className,
                            classes,
                            anchorOrigin = null,
                            transformOrigin = null,
                            marginThreshold = 16,
                        }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    /**
     * Show the popover
     * @type {(function(*): void)}
     */
    const onEnter = useCallback((event) => {
        setAnchorEl(event.currentTarget);
    }, []);


    /**
     * Hide the popover
     * @type {function(): void}
     */
    const onLeave = useCallback(() => {
        setAnchorEl(null);
    }, [])

    return (
        <>
            {child(onEnter, onLeave)}
            <MuiPopover
                classes={classes}
                className={className}
                elevation={elevation}
                id={id}
                open={!!anchorEl}
                anchorEl={anchorEl}
                marginThreshold={marginThreshold}
                anchorOrigin={anchorOrigin ?? {
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={transformOrigin ?? {
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={onLeave}
                disableRestoreFocus
            >
                {popoverChild(onEnter, onLeave)}
            </MuiPopover>
        </>

    );
};
